/** href tel: con el número limpio (deja solo dígitos y +). Abre la app de teléfono/RingCentral local. */
export function telHref(phone: string): string {
  const cleaned = String(phone ?? '').replace(/[^0-9+]/g, '');
  return `tel:${cleaned}`;
}

/** ¿Parece un teléfono con dígitos suficientes para marcar? (evita renderizar links a basura). */
export function looksDialable(phone: string | null | undefined): boolean {
  return String(phone ?? '').replace(/[^0-9]/g, '').length >= 7;
}
